const REBOOK_RESERVATION_ID_KEY = 'rebook_reservation_id';
export const addRebookParamToUrl = (fullUrl, rebookReservationId) => {
    if (!rebookReservationId) {
        return fullUrl;
    }
    // Handle relative full URL
    const url = new URL(fullUrl, window.location.origin);
    // When the param is already present, don't add it again
    if (url.searchParams.get(REBOOK_RESERVATION_ID_KEY)) {
        return fullUrl;
    }
    url.searchParams.set(REBOOK_RESERVATION_ID_KEY, rebookReservationId);
    // return relative URL
    return url.pathname + url.search;
};
